// The app topbar: the two slots MainLayout renders into the shell.
//
// This lives in src/app rather than src/components because it embeds feature
// components -- Search's SearchBox and Notification's bell -- and a shared
// component library must not depend on features (#33). The shell composing
// features is the sanctioned direction (app -> features -> core, #20).
//
// src/components/Headers/SubHeaders stays where it is: it has no feature
// imports, 21 Warehouse files and others depend on it, and where that page-
// chrome primitive should finally live is a separate question (#55 / #59).
import { OPEN_GLOBAL_SEARCH } from '@/constants/events'
import NotificationComp from '@/modules/Notification/components/Notification'
import { useTranslation } from 'react-i18next'
import TopbarAction from '@/components/TopbarAction'
import Search from './Search'
import { PageTrailSlot } from '@/components/Headers/SubHeaders'
import AccountDropdown from '@/components/AccountDropdown'
import AlertNotification from '@/components/AlertNotification'
import WhatsNewButton from '@/components/WhatsNew/WhatsNewButton'
import HelpMenu from '@/components/HelpMenu'
import LanguageSwitch from '@/components/LanguageSwitch'
import FestiveSwitch from '@/components/Festive/FestiveSwitch'
import { ErrorBoundary } from '@vnetwork/datacentral-ui/feedback'
import { SearchIcon } from 'lucide-react'

/** Topbar start slot: the page trail (breadcrumb + status) that pages fill. */
export function HeaderStart() {
    return <PageTrailSlot />
}

/** Sidebar header: the global search, the app's one search box. */
export function SidebarSearch() {
    return (
        <ErrorBoundary>
            <Search />
        </ErrorBoundary>
    )
}

/** Topbar end slot: festive switch, alerts, notifications, release notes, help and the account menu. */
export function HeaderActions() {
    const { t } = useTranslation()
    return (
        <ErrorBoundary>
            <div className="flex items-center gap-1 md:gap-2">
                <FestiveSwitch />
                <TopbarAction
                    icon={SearchIcon}
                    className="md:hidden"
                    aria-label={t('search')}
                    tooltip={null}
                    onClick={() =>
                        window.dispatchEvent(new Event(OPEN_GLOBAL_SEARCH))
                    }
                />
                <AlertNotification />
                <NotificationComp />
                <WhatsNewButton />
                <HelpMenu />
                <LanguageSwitch />
                <AccountDropdown />
            </div>
        </ErrorBoundary>
    )
}
